import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * Guards admin-only routes.
 * - Not logged in  -> redirect to /login
 * - Logged in but not an admin -> redirect to home
 * - Admin -> render the page
 *
 * NOTE: This is a UI-level guard only. Real security must also be
 * enforced on the backend (verify the JWT + isAdmin on every admin API).
 */
function AdminRoute({ children }) {
  let userInfo = null;

  try {
    userInfo = JSON.parse(localStorage.getItem('userInfo'));
  } catch (e) {
    userInfo = null;
  }

  if (!userInfo) {
    return <Navigate to="/login" replace />;
  }

  if (!userInfo.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

export default AdminRoute;
